import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { contentUpdatesAtom, excludedAtom } from './atoms'
import { excludedColumns } from './tableColumns'
import { Box, Button } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import React from 'react'

export function ExcludedTable() {
  const { excluded } = useAtomValue(contentUpdatesAtom)
  return (
    <Box>
      <Table
        title={`Excluded Total: ${excluded.length}`}
        columns={excludedColumns}
        items={excluded}
        toolBarItems={[<IncludeAllButton key="include" />]}
      />
    </Box>
  )
}

function IncludeAllButton() {
  const [, setExcluded] = useAtom(excludedAtom)
  const doExclude = () => setExcluded([])
  return <Button onClick={doExclude}>Include All</Button>
}
